const SEO = [
	{
		page: "home",
		description:
			"Emmanuel Mmanda is a Tanzania-based Software Engineer building APIs, integrations, USSD/SMS services, and practical digital products.",
		keywords: ["Software Engineer", "Emmanuel Mmanda", "Tanzania developer"],
	},

	{
		page: "about",
		description:
			"Learn about Emmanuel Mmanda's experience in backend engineering, integrations, cloud systems, and digital services.",
		keywords: ["Software Engineer", "backend engineer", "Emmanuel Mmanda"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Software Engineer", "Emmanuel Mmanda", "Tanzanian Developers"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Software Engineer", "Emmanuel Mmanda", "Tanzanian Developers"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Software Engineer", "Emmanuel Mmanda", "Tanzanian Developers"],
	},
];

export default SEO;
